// FTEDN Team App — React entry point
// ⚠️ Sentry MUST init before any other imports to catch early errors
import { initSentry } from './services/sentry';
import { redirectCloudRunTeamOrigin } from './services/production-origin';

initSentry();
redirectCloudRunTeamOrigin();

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '../../../shared/tokens.css';
import './styles/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
